<script lang="ts">import { isMobile, loggedIn } from "@infinitro/global";
import { bigCardPublic, smallCards } from "./data/alternative2";
import BigCardPlayer from "./parts/top-section-alternative2/big-card-player.svelte";
import BigCardPublic from "./parts/top-section-alternative2/big-card-public.svelte";
import SmallCard from "./parts/top-section-alternative2/small-card.svelte";
let containerWidth = 1200;
let actualWidth = 0;
let scale = 1;
const rankIconSizeMobile = 100;
const rankIconSizeDesktop = 200;
$: {
	if (actualWidth > 0) {
		// SOLO desktop escala
		scale = $isMobile ? 1 : Math.min(actualWidth / containerWidth, 1);
	}
}
$: reactiveSmallCards = smallCards.map((card) => card.linkUrl === "/vip" ? {
	...card,
	linkUrl: $loggedIn ? "/vip-dashboard/" : "/vip"
} : card);
$: wrapperHeightStyle = $isMobile ? "auto" : `${275 * scale}px`;
</script>

<div class="wrapper" bind:clientWidth={actualWidth} style="height: {wrapperHeightStyle};">
	<div
		class="top-section-alternative2"
		style="
			width: {$isMobile ? '100%' : `${containerWidth}px`};
			transform: {$isMobile ? 'none' : `scale(${scale})`};
			transform-origin: top left;
		"
	>
		<div class="big-card-container">
			{#if !$loggedIn}
				<BigCardPublic
					backgroundImage={bigCardPublic.backgroundImage}
					backgroundImageMobile={bigCardPublic.backgroundImageMobile}
					title={bigCardPublic.title}
					description={bigCardPublic.description}
					bonusAmount={bigCardPublic.bonus_amount}
					numberOfDeposits={bigCardPublic.number_of_deposits}
				/>
			{:else}
				<BigCardPlayer {rankIconSizeMobile} {rankIconSizeDesktop} />
			{/if}
		</div>
		<div class="small-cards-container">
			{#each reactiveSmallCards as card}
				<SmallCard
					backgroundImage={card.backgroundImage}
					backgroundImageMobile={card.backgroundImageMobile}
					title={card.title}
					description={card.description}
					linkUrl={card.linkUrl}
					badgeText={card.badgeText}
					badgeGradient={card.badgeGradient}
					position={card.position}
				/>
			{/each}
		</div>
	</div>
</div>

<style>
	.wrapper {
		width: 100%
}

	.top-section-alternative2 {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 0.5rem
}

	.big-card-container {
		height: 100%;
		min-height: 150px;
		width: 100%
}

	.small-cards-container {
		display: flex;
		height: 100%;
		width: 100%;
		flex-wrap: wrap;
		gap: 0.5rem
}

	@media (min-width: 1024px) {
		.top-section-alternative2 {
				display: flex;
				flex-direction: row;
				gap: 0.5rem;
			width: 1200px;
			height: 250px
		}

		.big-card-container {
				height: 100%;
			width: calc(50% - 0.25rem)
		}

		.small-cards-container {
				display: flex;
				height: 100%;
				flex-wrap: wrap;
				gap: 0.5rem;
			width: calc(50% - 0.25rem)
		}
	}
</style>
